import { useCallback, useMemo } from 'react'
import { useState } from 'react'

import { BaseLayout, Head } from '@/components/layouts'
import { TutorialStep } from '@/components/organisms'
import { Steps } from '@/components/organisms/functionals'
import { config } from '@/config'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'
import { getRedirectAfterLoginPath } from '@/core/native/storage'

export * from './fragments'

export type State = {}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {}

export const TutorialTemplate: Template<State, Action> = () => {
  const { t } = useTranslation('common')
  const { routerNames, router, routerPages } = useRouter()
  const [currentStep, setCurrentStep] = useState<number>(0)
  const images = useMemo<string[]>(() => config.tutorials, [])

  const handleSkip = useCallback(() => {
    getRedirectAfterLoginPath().then(({ value }) =>
      router.replace(value ?? routerPages.GlobalHome)
    )
  }, [router, routerPages.GlobalHome])

  const handleNextSteps = useCallback(() => {
    if (currentStep === images.length - 1) {
      handleSkip()
      return
    }
    setCurrentStep(prev => prev + 1)
  }, [currentStep, handleSkip, images.length])

  return (
    <>
      <Head title={routerNames.Tutorial} />
      <BaseLayout>
        <Steps value={currentStep}>
          {images.map((image, index) => (
            <TutorialStep
              key={index}
              image={{ uri: image }}
              caption={t(`tutorialCaption${index}`)}
              title={t(`tutorialTitle${index}`)}
              onNextStep={handleNextSteps}
              onSkip={handleSkip}
              currentStep={currentStep}
              stepLength={images.length}
            />
          ))}
        </Steps>
      </BaseLayout>
    </>
  )
}
